export const Fragment = Symbol.for('@antv/infographic/Fragment');
export function jsx(type, props = {}) {
    return { type, props };
}
export function createFragment(props = {}) {
    return jsx(Fragment, props);
}
export const jsxs = jsx;
export const jsxDEV = jsx;
